module.exports = __webpack_public_path__ + "static/img/icon_sbjj.e7411c3d.jpg";